// extracted by mini-css-extract-plugin
export default {"share":"a83dJv"};